/** @format */

// import { useState } from 'react';
import Container from '@mui/material/Container';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import PulseLoader from 'react-spinners/PulseLoader';

const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#b71c1c',
    },
    secondary: {
      main: '#e0e0e0',
    },
    warning: {
      main: '#ff9100',
    },
  },
};

export default function PasswordGenerator({
  password,
  getPassword,
  loading,
  isCopied,
  copyPassword,
}) {
  let theme = createTheme(deepmerge(themeOptions));

  return (
    <ThemeProvider theme={theme}>
      <Container
        maxWidth="xs"
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <TextField
          sx={{
            // p: '3px',
            m: '10px',
            fontSize: '22px',
            borderColor: theme.palette.success.main,
            backgroundColor: theme.palette.secondary.light,
          }}
          label={isCopied ? 'Success!' : 'Copy Password'}
          id="outlined-basic"
          color={isCopied ? 'success' : 'error'}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <ContentCopyIcon />
              </InputAdornment>
            ),
          }}
          onClick={copyPassword}
          value={password}
        />

        <Button
          variant="contained"
          color="error"
          onClick={async () => {
            await getPassword();
          }}
        >
          Generate Password{''}
          {loading && (
            <div style={{ marginTop: '5px', marginLeft: '10px' }}>
              <PulseLoader
                size={10}
                color={theme.palette.primary.contrastText}
              />
            </div>
          )}
        </Button>
      </Container>
    </ThemeProvider>
  );
}
